import api from './index'
import request from '@/utils/request'

/**
 * @description 获取登录验证码
 */
export function validCode (params) {
  return request({
    url: `${api.validCode}`,
    method: 'get',
    params
  })
}
/**
 * @description 获取行业类型列表
 */
export function getMcc (data) {
  return request({
    url: `${api.getMcc}`,
    method: 'post',
    data
  })
}
/**
 * @description 行业类型
 */
export function mccTypeList (data) {
  return request({
    url: `${api.mccTypeList}`,
    method: 'post',
    data
  })
}
/**
 * @description 行业类型细类
 */
export function mccGroupList (params) {
  return request({
    url: `${api.mccGroupList}`,
    method: 'get',
    params
  })
}
/**
 * @description 获取银行信息
 */
export function getBankList (data) {
  return request({
    url: `${api.getBankList}`,
    method: 'post',
    data
  })
}
/**
 * @description 银行卡号获取银行类型
 */
export function validBankCard (data) {
  return request({
    url: `${api.validBankCard}`,
    method: 'post',
    data
  })
}
/**
 * @description 根据联行号查网点信息
 */
export function findBranch (data) {
  return request({
    url: `${api.findBranch}`,
    method: 'post',
    data
  })
}
/**
 * @description 获取城市列表（支付宝地区码）
 */
export function getProvinceAlipay (data) {
  return request({
    url: `${api.getProvinceAlipay}`,
    method: 'post',
    data
  })
}
/**
 * @description 获取城市列表（支付宝地区码）
 */
export function getCityAlipay (data) {
  return request({
    url: `${api.getCityAlipay}`,
    method: 'post',
    data
  })
}
/**
 * @description 获取区列表（支付宝地区码）
 */
export function getAreaAlipay (data) {
  return request({
    url: `${api.getAreaAlipay}`,
    method: 'post',
    data
  })
}
/**
 * @description 获取代理商的真实账户
 */
export function getAgentRealAccount (params) {
  return request({
    url: `${api.getAgentRealAccount}`,
    method: 'get',
    params
  })
}
/**
 * @description 获取商户的真实账户
 */
export function getMerchantRealAccount (params) {
  return request({
    url: `${api.getMerchantRealAccount}`,
    method: 'get',
    params
  })
}
/**
 * @description 更新图片临时地址
 */
export function singleTransPic (data) {
  return request({
    url: `${api.singleTransPic}`,
    method: 'post',
    data
  })
}
/**
 * @description 上传照片
 */
export function uploadPic (data) {
  return request({
    url: `${api.uploadPic}`,
    method: 'post',
    data
  })
}
/**
 * @description 代理商入网意向调查
 */
export function agentSurvey (data) {
  return request({
    url: `${api.agentSurvey}`,
    method: 'post',
    data
  })
}
/**
 * @description 代理商入网根据授权码获取信息
 */
export function getInfoByAuthCode (data) {
  return request({
    url: `${api.getInfoByAuthCode}`,
    method: 'post',
    data
  })
}
/**
 * @description 上传补充资料
 */
export function uploadExtendFile (data) {
  return request({
    url: `${api.uploadExtendFile}`,
    method: 'post',
    data
  })
}
/**
 * @description OCR识别图片
 */
export function ocrCheck (data) {
  return request({
    url: `${api.ocrCheck}`,
    method: 'post',
    data
  })
}
/**
 * @description 更改绑定手机号
 */
export function modifyMerchantMobile (params) {
  return request({
    url: `${api.modifyMerchantMobile}`,
    method: 'get',
    params
  })
}
/**
 * @description 修改绑定手机号获取验证码接口
 */
export function getModifyMobileCode (params) {
  return request({
    url: `${api.getModifyMobileCode}`,
    method: 'get',
    params
  })
}
/**
 * @description 更改手机号前预处理
 */
export function preModifyMobile (data) {
  return request({
    url: `${api.preModifyMobile}`,
    method: 'post',
    data
  })
}
/**
 * @description 更改手机号前预处理
 */
export function getAreaCode (data) {
  return request({
    url: `${api.getAreaCode}`,
    method: 'post',
    data
  })
}
/**
 * @description 更改手机号前预处理
 */
export function getBranch (data) {
  return request({
    url: `${api.getBranch}`,
    method: 'post',
    data
  })
}
/**
 * @description 上传视频前获取token
 */
export function getUploadToken (data) {
  return request({
    url: `${api.getUploadToken}`,
    method: 'post',
    data
  })
}
/**
 * @description 修改商户的密码
 */
export function changeMerchantPs (data) {
  return request({
    url: `${api.changeMerchantPs}`,
    method: 'post',
    data
  })
}

/**
 * @description 修改代理商账号密码
 */
export function changePs (data) {
  return request({
    url: `${api.changePs}`,
    method: 'post',
    data
  })
}

/**
 * @description 根据分行码查询分行信息
 */
export function getBranchByCode (data) {
  return request({
    url: `${api.getBranchByCode}`,
    method: 'post',
    data
  })
}

/**
 * @description 根据mccCode查询行业信息
 */
export function getMccByCode (data) {
  return request({
    url: `${api.getMccByCode}`,
    method: 'post',
    data
  })
}

/**
 * @description 根据地区吗查询地区信息
 */
export function getAreaByCode (data) {
  return request({
    url: `${api.getAreaByCode}`,
    method: 'post',
    data
  })
}
